import React, { useState, useEffect, useRef, useCallback } from 'react';
import Board from './Board';
import { TaskContext, ColumnContext } from '../context';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { v4 as uuid } from 'uuid';
import services from '../services';
import Header from '../components/Header';
import InboxData from '../components/Inbox/InboxData';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { socket, gmailSocket } from '../socket';
import { boardLocal, columnsLocal, tasksLocal, userDataLocal } from '../utils/LocalSt';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import WhatsappData from '../components/Inbox/WhatsappData';
import WhatsAppAuth from './WhatsAuthUser';
import EmailAuth from './EmailAuthUser';
import SearchBar from 'material-ui-search-bar';
import { addColumnsDetails, setEmailStatus, setWhatsAppStatus } from '../Redux/slice';
import { MultiSelect } from 'react-multi-select-component';
import { getAllDateTableTask, getTaskMail } from '../Redux/GetSlice';
import { use } from 'react';
import Loading from '../utils/Loading';
import { dataMerger } from '../utils/dataMerger';

const AppViewer = () => {
    const tasksInMemory = tasksLocal() || [];
    const [tasks, setTasks] = useState(tasksInMemory);
    const [taskList, setTaskList] = useState([]);
    const [originalTaskList, setOriginalTaskList] = useState([]);
    const [filterList, setFilterList] = useState();

    const [selectedEmailsIds, setSelectedEmailsIds] = useState(() => {
        const saved = localStorage.getItem('selectedEmailsIds');
        if (saved) {
            try {
                const parsed = JSON.parse(saved);
                if (Array.isArray(parsed)) {
                    return parsed;
                }
            } catch (e) {
                console.error('Failed to parse selectedEmailsIds from localStorage', e);
            }
        }
        return [];
    });
    const [selectedMailId, setSelectedMailId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [emailLimit, setEmailLimit] = useState(10);
    const [emailName, setEmailName] = useState([]);
    const [selectedBoardId, setSelectedBoardId] = useState('');
    const [selected, setSelected] = useState('');
    const [selectedWhatspp, setSelectedWhatspp] = useState('');
    const [allWhatsappData, setAllWhatsappData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const moduleName = 'board';
    const [columns, setColumns] = useState([]);
    const [open, setOpen] = useState(false);
    const [selectedBoard, setSelectedBoard] = useState([]);
    const [localSt, setLocalSt] = useState(boardLocal());
    const [isShiftPressedMail, setIsShiftPressedMail] = useState(false);
    const [valueTab, setValueTab] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [pageWhatsapp, setPageWhatsapp] = useState(1);
    // const [whatsAppStatus, setWhatsAppStatus] = useState(false);
    // const [emailStatus, setEmailStatus] = useState(false);
    const [searched, setSearched] = useState('');
    const [labelEmail, setLabelEmail] = useState('CATEGORY_PERSONAL');
    const [columnAddStatus, setColumnAddStatus] = useState(false);
    const [pendingRemoval, setPendingRemoval] = useState(new Set());
    const dispatch = useDispatch();
    const userData = userDataLocal() || {};
    const { role, id } = userData;
    const sidebarRef = useRef(null);
    const [allWhatsaapUserProfile, setAllWhatsaapUserProfile] = useState([]);
    const [selectedProfileId, setSelectedProfileId] = useState('');
    const [boardName, setBoardName] = useState([]);
    const [isBoardFetched, setIsBoardFetched] = useState(false);
    const [sortby, setSortBy] = useState('title');
    const [sortOrder, setSortOrder] = useState('ASC');
    const [activeButton, setActiveButton] = useState('board');
    const { columnIndex, selectedTab, whatsAppStatus, emailStatus } = useSelector(
        (state) => ({
            columnIndex: state.redux.columnIndex,
            selectedTab: state.redux.selectedTab,
            whatsAppStatus: state.redux.whatsAppStatus,
            emailStatus: state.redux.emailStatus,
        }),
        (prev, next) =>
            prev.columnIndex === next.columnIndex &&
            prev.selectedTab === next.selectedTab &&
            prev.whatsAppStatus === next.whatsAppStatus &&
            prev.emailStatus === next.emailStatus,
    );

    const { isTableVisible } = useSelector((state) => state?.redux);
    const [noMailFound, setNoMailFound] = useState(false);
    const [inboxFilterMailData, setInboxFilterMailData] = useState([]);
    const [taskMail, setTaskMail] = useState([]);
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [debouncedSearch, setDebouncedSearch] = useState(searched);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [boardLoading, setBoardLoading] = useState(false);
  
    const handleScrollWhatsapp = () => {
        const sidebar = sidebarRef.current;
        if (!sidebar) return;

        if (sidebar.scrollTop + sidebar.clientHeight >= sidebar.scrollHeight) {
            GET_CONTACT_WHATSAPP(page + 1, selectedProfileId);
            setPage(page + 1);
        }
    };
    const UserId = userDataLocal()?.id;
    useEffect(() => {
        const sidebar = sidebarRef.current;
        if (!sidebar) return;

        sidebar.addEventListener('scroll', handleScrollWhatsapp);
        return () => sidebar.removeEventListener('scroll', handleScrollWhatsapp);
    }, [page, selectedProfileId]);

    useEffect(() => {
        localStorage.setItem('tasks', JSON.stringify(tasks));
    }, [tasks, columns]);

    const handleClick = (category) => {
        setSelected(category);
        if (category === 'primary') {
            setOpen();
        }
    };

    useEffect(() => {
        const savedBoard = localStorage.getItem('board');
        if (savedBoard) {
            try {
                const parsedBoard = JSON.parse(savedBoard);
                setSelectedBoard(parsedBoard);
                setSelectedBoardId(parsedBoard.value);
                handleSelectedBoard(parsedBoard);
            } catch (error) {
                console.error('Error parsing saved board:', error);
                localStorage.removeItem('board');
            }
        }
    }, []);

    useEffect(() => {
        const initializeBoard = () => {
            const savedBoard = localStorage.getItem('board');
            if (savedBoard) {
                try {
                    const parsedBoard = JSON.parse(savedBoard);
                    if (!selectedBoardId || selectedBoardId !== parsedBoard.value) {
                        setSelectedBoard(parsedBoard);
                        setSelectedBoardId(parsedBoard.value);
                        handleSelectedBoard(parsedBoard);
                    }
                } catch (error) {
                    console.error('Error parsing saved board:', error);
                    localStorage.removeItem('board');
                }
            }
        };

        initializeBoard();
    }, []);

    useEffect(() => {
        setLocalSt(boardLocal());
    }, [localStorage.getItem('board')]);

    useEffect(() => {
        if (boardName && boardName.length > 0 && !selectedBoardId) {
            const savedBoard = localStorage.getItem('board');
            if (savedBoard) {
                try {
                    const parsedBoard = JSON.parse(savedBoard);
                    const boardExists = boardName.some((b) => b.value === parsedBoard.value);
                    if (boardExists) {
                        setSelectedBoard(parsedBoard);
                        setSelectedBoardId(parsedBoard.value);
                        handleSelectedBoard(parsedBoard);
                    } else {
                        setSelectedBoard(boardName[0]);
                        setSelectedBoardId(boardName[0].value);
                        handleSelectedBoard(boardName[0]);
                    }
                } catch (error) {
                    console.error('Error parsing saved board:', error);
                    setSelectedBoard(boardName[0]);
                    setSelectedBoardId(boardName[0].value);
                    handleSelectedBoard(boardName[0]);
                }
            } else {
                setSelectedBoard(boardName[0]);
                setSelectedBoardId(boardName[0].value);
                handleSelectedBoard(boardName[0]);
            }
        }
    }, [boardName, selectedBoardId]);

    const getColor = (category) => {
        return selected === category ? 'text-blue-500 border-b-4 border-blue-500' : 'text-current';
    };

    const getColorWhatsapp = (category) => {
        return selectedWhatspp === category ? 'text-blue-500 border-b-4 border-blue-500' : 'text-current';
    };

    const moveTaskUp = (taskId) => {
        setTasks((prevTasks) => {
            const taskIndex = prevTasks.findIndex((task) => task.id === taskId);
            if (taskIndex > 0 && prevTasks[taskIndex].columnId === prevTasks[taskIndex - 1].columnId) {
                const updatedTasks = [...prevTasks];
                [updatedTasks[taskIndex - 1], updatedTasks[taskIndex]] = [
                    updatedTasks[taskIndex],
                    updatedTasks[taskIndex - 1],
                ];
                return updatedTasks;
            }
            return prevTasks;
        });
    };

    const moveTaskDown = (taskId) => {
        setTasks((prevTasks) => {
            const taskIndex = prevTasks.findIndex((task) => task.id === taskId);
            if (
                taskIndex < prevTasks.length - 1 &&
                prevTasks[taskIndex].columnId === prevTasks[taskIndex + 1].columnId
            ) {
                const updatedTasks = [...prevTasks];
                [updatedTasks[taskIndex + 1], updatedTasks[taskIndex]] = [
                    updatedTasks[taskIndex],
                    updatedTasks[taskIndex + 1],
                ];
                return updatedTasks;
            }
            return prevTasks;
        });
    };

    const addTaskToColumn = ({ title, user, columnId, date, deadlineDate }) => {
        const newTask = {
            id: uuid(),
            title,
            user,
            columnId,
            date,
            deadlineDate,
        };
        const updatedTasks = [...tasks, newTask];
        setTasks(updatedTasks);
        localStorage.setItem('tasks', JSON.stringify(updatedTasks));
    };

    const updateTitleInLocalStorage = (itemId, editTaskTitle) => {
        const existingData = tasksLocal() || [];
        const updatedData = existingData?.map((item) => {
            if (item.id === itemId) {
                return { ...item, title: editTaskTitle };
            }
            return item;
        });
        setTasks(updatedData);
        localStorage.setItem('tasks', JSON.stringify(updatedData));
    };

    const updateColunTitleInLocalStorage = (columnID, editColumnTitle) => {
        const existingData = columnsLocal() || [];
        const updatedData = existingData?.map((item) => {
            if (item.id === columnID) {
                return { ...item, title: editColumnTitle };
            }
            return item;
        });
        setColumns(updatedData);
    };

    const getAllInboxMailFilter = async (currentPage) => {
        setLoading(true);
        const data = {
            page: currentPage,
            limit: 10,
        };
        if (selectedEmailsIds.length > 0) {
            data.gmailUserId = selectedEmailsIds.map((element) => element.value);
        }
        const query = new URLSearchParams(data).toString();

        const response = await services.email.GET_EMAIL_BY_SELECTED_USER(query);
        const emails = response?.data?.data?.emails || [];

        const filteredEmails = emails.filter((item) => !pendingRemoval.has(item.gmailMessageId));

        setInboxFilterMailData((prev) => (currentPage === 1 ? filteredEmails : [...prev, ...filteredEmails]));
        setTotalPages(Math.ceil(response?.data?.data?.total / 10));
        setLoading(false);

        if (filteredEmails.length > 0) {
            const currentSelectedIdExists = filteredEmails.some((email) => email.gmailMessageId === selectedMailId);
            if (!currentSelectedIdExists) {
                setSelectedMailId(filteredEmails[0].gmailMessageId);
            }
        } else {
            setSelectedMailId(null);
        }
    };

    const updateDeadlineDateInLocalStorage = (itemId, date) => {
        const updatedTasks = tasks.map((task) => {
            if (task.id === itemId) {
                return { ...task, deadline: date };
            }
            return task;
        });
        setTasks(updatedTasks);
        localStorage.setItem('tasks', JSON.stringify(updatedTasks));
    };

    const handleUpdateTask = async (newDate, type = 'reminder', taskItem) => {
        try {
            const data = {
                [type]: newDate,
            };
            const response = await services.task.UPDATE_TASK(taskItem?.id, data);
            if (response) {
                getTaskMailIndbox();
            }
        } catch (error) {
            console.error('Error updating task:', error);
        }
    };

    const handleCheckboxClick = () => {
        setIsModalOpen(!isModalOpen);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleViewDetails = (item) => {
        navigate('/mailinbox', { state: { selectedMail: item } });
    };

    const handleAddColumn = async (columnInputAdd) => {
        const currentBoardId = getCurrentBoardId();
        if (!currentBoardId) {
            toast.error('Please select a board before adding a list.');
            return;
        }
        if (!columnInputAdd || typeof columnInputAdd !== 'string' || columnInputAdd.trim() === '') {
            toast.error('Please enter a valid list name.');
            return;
        }

        const trimmedInput = columnInputAdd.trim().toLowerCase();
        const isDuplicate = columns.some(
            (col) => typeof col?.title === 'string' && col?.title?.trim().toLowerCase() === trimmedInput,
        );

        if (isDuplicate) {
            toast.error('List name already exists, please choose another name.');
            return;
        }

        const obj = {
            coloum: columnInputAdd.trim(),
            boardId: currentBoardId,
            sequence: columns?.length + 1,
            className: '#00f767',
            borderColor: '#00f767',
        };

        try {
            await services.column.CREATE_COLUMN(obj);
            handleSelectedBoard(selectedBoard);
            toast.success('Column created successfully.');
        } catch (e) {
            console.error('Error adding column:', e);
            toast.error('Failed to add column.');
        }
    };

    const moveColumn = (fromIndex, toIndex) => {
        setColumns((prevColumns) => {
            const newColumns = [...prevColumns];
            const [movedColumn] = newColumns.splice(fromIndex, 1);
            newColumns.splice(toIndex, 0, movedColumn);

            updateColumnSequence(newColumns);

            return newColumns;
        });
    };

    const updateColumnSequence = async (columns) => {
        const sequenceData = columns.map((col, index) => ({
            id: col.id,
            sequence: index + 1,
        }));

        try {
            await services.board.SEQUENCE(sequenceData, boardLocal()?.value);
        } catch (e) {
            console.error('Error updating sequence:', e);
        }
    };

    const handleSelectedBoard = async (id) => {
        if (!id?.value) {
            return;
        }

        try {
            if (role === 'User') {
                const response = await services.userassignboard.GET_UserAssignBoard_ID(UserId);
                const assignedBoards = response?.data?.data || [];

                const assignedBoard = assignedBoards.find((board) => board.boardId === id.value);

                const assignedColumns = (assignedBoard?.boardListId || []).map((col) => ({
                    id: col.value,
                    title: col.label,
                    className: col.colour || '#00f767',
                    borderColor: col.colour || '#00f767',
                }));

                dispatch(addColumnsDetails(assignedColumns));
                localStorage.setItem('board', JSON.stringify(id));
                setColumns(assignedColumns);
            } else {
                const response = await services.board.SELECTED_BOARD(id?.value);
                const data = response?.data?.map((item) => ({
                    id: item?.id,
                    title: item?.coloum,
                    className: item?.colour,
                    borderColor: item?.colour,
                }));

                dispatch(addColumnsDetails(data));
                localStorage.setItem('board', JSON.stringify(id));
                setColumns(data);
            }
        } catch (e) {
            console.error('Error fetching board:', e);
        }
    };

    const getTaskMailIndbox = useCallback(async () => {
        setLoading(true);

        const currentBoardId = getCurrentBoardId();
        if (!currentBoardId) {
            console.warn('No board ID available. selectedBoardId:', selectedBoardId, 'localSt:', localSt?.value);
            setLoading(false);
            return;
        }

        if (!Array.isArray(selectedEmailsIds) || selectedEmailsIds.length === 0) {
            console.warn('No selected email IDs provided. Skipping API call.');
            setLoading(false);
            return;
        }
        try {
            const data = {
                limit: emailLimit,
                page: 1,
                boardId: currentBoardId,
                search: searched || '',
            };
            if (selectedEmailsIds.length > 0) {
                data.gmailUserId = selectedEmailsIds.map((element) => element.value);
            }
            const query = new URLSearchParams(data).toString();
            const response = await services.email.GET_EMAIL_BY_DATE(query, currentBoardId);

            if (response?.data?.emails && Array.isArray(response.data.emails)) {
                setOriginalTaskList(response.data.emails);
                const filteredList = response.data.emails.filter((item) => !pendingRemoval.has(item.gmailMessageId));

                if (filteredList.length === 0) {
                    setNoMailFound(true);
                }
            } else {
                console.warn('No emails found in response:', response?.data);
                setOriginalTaskList([]);
                setTaskList([]);
                setNoMailFound(true);
            }
        } catch (error) {
            console.error('Error fetching task emails:', error);
            setNoMailFound(true);
        } finally {
            setLoading(false);
        }
    }, [selectedBoardId, emailLimit, labelEmail, searched, selectedEmailsIds, pendingRemoval, localSt]);

    const handleChange = async (selectedOptions) => {
        setSelectedEmailsIds(selectedOptions);
        localStorage.setItem('selectedEmailsIds', JSON.stringify(selectedOptions));
    };
    const handleEmailSync = async (newEmails) => {
        const getHeaderValue = (headers, name) => {
            if (!headers || !Array.isArray(headers)) return '';
            const header = headers.find((h) => h.name?.toLowerCase() === name.toLowerCase());
            return header?.value || '';
        };

        const decodeBase64 = (str) => {
            try {
                return atob(str.replace(/-/g, '+').replace(/_/g, '/'));
            } catch (err) {
                console.warn('Base64 decode failed:', err);
                return '';
            }
        };

        const extractBody = (parts) => {
            if (!Array.isArray(parts)) return '';
            for (const part of parts) {
                if (['text/plain', 'text/html'].includes(part.mimeType)) {
                    if (part.body?.data) {
                        return decodeBase64(part.body.data);
                    }
                }
                if (Array.isArray(part.parts)) {
                    const nested = extractBody(part.parts);
                    if (nested) return nested;
                }
            }
            return '';
        };

        const parsedEmails = newEmails.map((newEmail) => {
            const payload = newEmail.payload;

            return {
                id: Date.now() + Math.random(),
                gmailMessageId: newEmail?.id || '',
                attachmentPaths: null,
                boardId: null,
                body: (() => {
                    if (payload?.body?.data) {
                        return decodeBase64(payload.body.data);
                    } else if (payload?.parts) {
                        return extractBody(payload.parts);
                    }
                    return newEmail?.snippet || '';
                })(),
                contactId: null,
                createdAt: new Date().toISOString(),
                createdAtEmail: (() => {
                    const timestamp = parseInt(newEmail?.internalDate);
                    return isNaN(timestamp) ? new Date().toISOString() : new Date(timestamp).toISOString();
                })(),
                fetchedAt: new Date().toISOString(),
                gmailUserId: selectedEmailsIds?.[0]?.value || '',
                isTaskCreated: false,
                labels: Array.isArray(newEmail?.labelIds) ? newEmail.labelIds.join(',') : '',
                messageRead: newEmail?.labelIds?.includes('UNREAD') ? 'unread' : 'read',
                name: (() => {
                    const from = getHeaderValue(payload?.headers, 'From');
                    return from ? from.split('<')[0].trim().replace(/"/g, '') : '';
                })(),
                sentBy: getHeaderValue(payload?.headers, 'From'),
                sentTo: getHeaderValue(payload?.headers, 'To'),
                subject: getHeaderValue(payload?.headers, 'Subject'),
                status: true,
                updatedAt: new Date().toISOString(),
                updatedAtEmail: null,
                isNew: true,
            };
        });
        getAllInboxMailFilter(1);
        getTaskMail();
    };

    useEffect(() => {
        setInboxFilterMailData([]);
        setPage(1);
        if (selectedEmailsIds?.length > 0) {
            getAllInboxMailFilter(1);
        }
        gmailSocket.on('email-sync', (newEmail) => {
            handleEmailSync(newEmail);
        });

        return () => {
            gmailSocket.off('email-sync');
        };
    }, [selectedEmailsIds]);

    const checkAndCreateAutomationTask = async (emailData) => {
        try {
            const allAutomations = await services.automations.GET_ALL_AUTOMATIONS();

            const matchingAutomation = allAutomations.find(
                (automation) => automation.when?.gmailUserId === emailData.gmailUserId && automation.status !== false,
            );

            if (matchingAutomation) {
                getTaskMail();

                return true;
            }

            return false;
        } catch (error) {
            console.error('Error in automation check:', error);
            return false;
        }
    };

    const getAllLinkedEmail = async () => {
        try {
            const response = await services.email.Get_The_Linked_Email();
            if (response) {
                const options = response?.data?.map((email) => ({
                    label: email.email,
                    value: email.id,
                    color: email.colour,
                }));
                setFilterList(options);
                const savedSelection = localStorage.getItem('selectedEmailsIds');
                if (savedSelection) {
                    try {
                        const parsed = JSON.parse(savedSelection);
                        if (Array.isArray(parsed) && parsed.length > 0) {
                            setSelectedEmailsIds(parsed);
                            return;
                        }
                    } catch (e) {
                        console.error('Failed to parse saved email selection', e);
                    }
                }
                if (options.length > 0) {
                    setSelectedEmailsIds([options[0]]);
                    localStorage.setItem('selectedEmailsIds', JSON.stringify([options[0]]));
                }
            }
        } catch (error) {
            console.error('Error getting linked emails:', error);
        }
    };
    const GET_CONTACT_WHATSAPP = async (page, id) => {
        if (!id) return;

        setLoading(true);
        try {
            let data;

            if (selectedWhatspp === 'groupWhatsappChat') {
                const response = await services.Whatsapp.GET_BY_GROUP_ID_WHATSAPP_PROFILE(id);
                data = response?.data;
            } else {
                const response = await services.Whatsapp.GET_BYID_WHATSAPP_PROFILE(id);
                data = response?.data;
            }

            const totalData = Math.ceil(data.totalCount / 10 || 0);
            if (page >= totalData) {
                setHasMore(false);
            }
            setAllWhatsappData(data?.data?.Contacts);
        } catch (e) {
            console.error('Error fetching contacts:', e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getAllLinkedEmail();
        getClientWhatsapp();
    }, [selectedTab]);

    useEffect(() => {
        if (selectedProfileId || selectedWhatspp) {
            GET_CONTACT_WHATSAPP(page, selectedProfileId);
        }
    }, [selectedProfileId, selectedWhatspp, page]);

    const getClientWhatsapp = async () => {
        try {
            const { data } = await services.Whatsapp.GET_ALL_CLIENT();
            const filterProfileData = data?.filter((item) => item?.name !== null && item?.name !== '');

            if (filterProfileData?.length > 0) {
                const firstId = filterProfileData[0]?.id;
                setSelectedProfileId(firstId);
                GET_CONTACT_WHATSAPP(page, firstId);
            }
            setAllWhatsaapUserProfile(filterProfileData || []);
        } catch (e) {
            console.error(e);
        }
    };

    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollTop + clientHeight >= scrollHeight - 50 && !loading && page < totalPages) {
            setPage((prev) => {
                const nextPage = prev + 1;
                getAllInboxMailFilter(nextPage);
                return nextPage;
            });
        }
    };

    const handleDragEnd = (gmailMessageId) => {
        setPendingRemoval((prev) => {
            const newPending = new Set(prev);
            if (newPending.has(gmailMessageId)) {
                newPending.delete(gmailMessageId);
                getAllInboxMailFilter(page);
            } else {
                newPending.add(gmailMessageId);

                setInboxFilterMailData(inboxFilterMailData.filter((item) => !newPending.has(item.gmailMessageId)));
            }
            return newPending;
        });
    };

    const generateMailInbox = () => {
        return (
            <>
                {inboxFilterMailData?.map((item) => (
                    <InboxData
                        key={item?.id}
                        item={item}
                        open={open}
                        setOpen={setOpen}
                        getTaskMailIndbox={getAllInboxMailFilter}
                        onCheckboxClick={handleCheckboxClick}
                        onViewDetails={() => handleViewDetails(item)}
                        setIsShiftPressedMail={setIsShiftPressedMail}
                        isShiftPressedMail={isShiftPressedMail}
                        taskList={taskList}
                        onDragEnd={handleDragEnd}
                        filterList={filterList}
                        role={role}
                        selectedEmailsIds={selectedEmailsIds}
                        handleChange={handleChange}
                        selectedMailId={selectedMailId}
                        setSelectedMailId={setSelectedMailId}
                        selectedBoardId={selectedBoardId}
                    />
                ))}

                {loading && (
                    <div style={{ textAlign: 'center', padding: '10px' }}>
                        <Loading />
                    </div>
                )}
            </>
        );
    };

    const getTaskMail = async (limitArg = 10, options = {}) => {
        const query = {
            limit: limitArg,
            boardId: selectedBoardId,
        };

        if (activeButton == 'table') {
            query.sortBy = sortby;
            query.sortOrder = sortOrder;
            query.query = 'table';
        }

        const obj = new URLSearchParams(query);

        try {
            const response = await services.task.GET_TASK(obj);
            if (response) {
                const totalTasks = Number(response?.data?.totalTasks) || 0;
                let data = JSON.parse(JSON.stringify(response?.data?.data));
                if (options.append) {
                    setTaskMail((prev) => {
                        const merged = { ...prev };
                        const dataKeys = data && typeof data === 'object' ? Object.keys(data) : [];
                        dataKeys.forEach((colId) => {
                            const prevArr = Array.isArray(prev?.[colId]) ? prev[colId] : [];
                            const newArr = Array.isArray(data?.[colId]) ? data[colId] : [];
                            const existingIds = new Set(prevArr.map((t) => t.id));
                            const combined = [...prevArr];
                            newArr.forEach((t) => {
                                if (!existingIds.has(t.id)) combined.push(t);
                            });
                            merged[colId] = combined;
                        });
                        return merged;
                    });
                } else {
                    setTaskMail(data);
                }
                return { data, totalTasks };
            }
        } catch (error) {
            console.error('Error fetching task emails:', error);
            return null;
        }
    };


    const handleGetWhatsappTask = (id) => {
        const data = [...allWhatsappData];
        if (data && data?.length > 0) {
            const filterData = data.filter((idFil) => idFil?.id !== id);

            setAllWhatsappData(filterData);
        }

        if (boardOptions.length === 0) {
            setColumns([]);
            dispatch(addColumnsDetails([]));
            localStorage.removeItem('columns');
            return;
        }
    };

    const generateWhatsAppInbox = () => {
        return allWhatsappData?.map((item, index) => {
            return (
                <WhatsappData
                    key={item?.id}
                    item={item}
                    setIsShiftPressedMail={setIsShiftPressedMail}
                    isShiftPressedMail={isShiftPressedMail}
                    index={index}
                    onItemDrag={(onItemDrag) => handleGetWhatsappTask(onItemDrag?.item?.id)}
                />
            );
        });
    };

    useEffect(() => {
        if (columnIndex?.from >= 0 && columnIndex?.to >= 0) {
            const updatedColumns = [...columns];
            const [movedColumn] = updatedColumns.splice(columnIndex?.from, 1);
            updatedColumns.splice(columnIndex?.to, 0, movedColumn);
            // localStorage.setItem('columns', JSON.stringify(updatedColumns));
            setColumns(updatedColumns);
            const sequenceFun = async () => {
                const data =
                    updatedColumns &&
                    updatedColumns?.length > 0 &&
                    updatedColumns?.map((item, index) => ({
                        id: item?.id,
                        sequence: index + 1,
                    }));
                if (data) {
                    try {
                        await services.board.SEQUENCE(data, boardLocal()?.value);
                    } catch (e) {
                        console.error(e);
                    }
                }
            };
            if (updatedColumns[0] != undefined) {
                sequenceFun();
            }
        }
    }, [columnIndex]);

    const handleChangeTab = (event, newValue) => {
        setValueTab(newValue);
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(searched);
        }, 500);
        return () => clearTimeout(timer);
    }, [searched]);

    useEffect(() => {
        if (debouncedSearch.length > 0 && selectedEmailsIds.length > 0) {
            requestSearch(debouncedSearch);
        }
    }, [debouncedSearch, selectedEmailsIds]);

    const requestSearch = async (searchedVal) => {
        setSearched(searchedVal);

        if (searchedVal.length > 0 && selectedEmailsIds.length > 0) {
            const emails = selectedEmailsIds.map((item) => item.label);
            try {
                setLoading(true);
                const response = await services.email.EMAIL_SEARCH_BY_QUERY(emails, searchedVal);

                setInboxFilterMailData(Array.isArray(response?.data?.data) ? response.data.data : []);

                setLoading(false);
            } catch (err) {
                setInboxFilterMailData([]);
                setNoMailFound(true);
            } finally {
                setLoading(false);
            }
        }
    };

    const cancelSearch = () => {
        setSearched('');
        requestSearch(searched);
    };

    const handleProfileChange = (value) => {
        setSelectedProfileId(value);
    };

    const getAllBoard = async () => {
        try {
            const { data } = await services.board.GETALLBOARD();
            const mapData = data?.map(({ boardName, id }) => ({ label: boardName, value: id }));

            let newlyAddedBoard = null;
            if (boardName.length > 0 && mapData.length > boardName.length) {
                const oldBoardIds = new Set(boardName.map((b) => b.value));
                newlyAddedBoard = mapData.find((b) => !oldBoardIds.has(b.value));
            }

            setBoardName(mapData);

            if (newlyAddedBoard) {
                setSelectedBoard(newlyAddedBoard);
                setSelectedBoardId(newlyAddedBoard.value);
                handleSelectedBoard(newlyAddedBoard);
                return;
            }

            if (mapData?.length > 0) {
                const savedBoard = localStorage.getItem('board');
                if (savedBoard) {
                    try {
                        const parsedBoard = JSON.parse(savedBoard);
                        const boardExists = mapData.some((b) => b.value === parsedBoard.value);
                        if (boardExists) {
                            if (!selectedBoardId || selectedBoardId !== parsedBoard.value) {
                                setSelectedBoard(parsedBoard);
                                setSelectedBoardId(parsedBoard.value);
                                handleSelectedBoard(parsedBoard);
                            }
                        } else {
                            if (!selectedBoardId || !mapData.some((b) => b.value === selectedBoardId)) {
                                setSelectedBoard(mapData[0]);
                                setSelectedBoardId(mapData[0].value);
                                handleSelectedBoard(mapData[0]);
                            }
                        }
                    } catch (error) {
                        console.error('Error parsing saved board:', error);
                        if (!selectedBoardId || !mapData.some((b) => b.value === selectedBoardId)) {
                            setSelectedBoard(mapData[0]);
                            setSelectedBoardId(mapData[0].value);
                            handleSelectedBoard(mapData[0]);
                        }
                    }
                } else {
                    if (!selectedBoardId || !mapData.some((b) => b.value === selectedBoardId)) {
                        setSelectedBoard(mapData[0]);
                        setSelectedBoardId(mapData[0].value);
                        handleSelectedBoard(mapData[0]);
                    }
                }
            } else {
                setBoardName([]);
                setSelectedBoard(null);
                setSelectedBoardId(null);
                handleSelectedBoard(null);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setBoardLoading(false);
            setIsBoardFetched(true);
        }
    };

    const getBoardColumnById = async () => {
        try {
            const response = await services.userassignboard.GET_UserAssignBoard_ID(UserId);
            const assignedBoards = response?.data?.data || [];
            const boardOptions = assignedBoards.map((assigned) => ({
                label: assigned.Board.boardName,
                value: assigned.Board.id,
                boardListId: assigned.boardListId,
                BoardLists: assigned.Board.BoardLists,
            }));
            setBoardName(boardOptions);
            let selected = null;
            const savedBoard = localStorage.getItem('board');
            if (savedBoard) {
                try {
                    const parsed = JSON.parse(savedBoard);
                    selected = boardOptions.find((b) => b.value === parsed.value) || boardOptions[0];
                } catch {
                    selected = boardOptions[0];
                }
            } else {
                selected = boardOptions[0];
            }
            setSelectedBoard(selected);
            setSelectedBoardId(selected?.value);
            localStorage.setItem('board', JSON.stringify(selected));

            if (boardOptions.length === 0) {
                setColumns([]);
                dispatch(addColumnsDetails([]));
                localStorage.removeItem('columns');
                return;
            }

            const columnsData = (selected?.BoardLists || selected?.boardListId || []).map((col) => ({
                id: col.id || col.value,
                title: col.coloum || col.label,
                className: col.colour || '#00F767',
                borderColor: col.colour || '#00F767',
            }));
            setColumns(columnsData);
            if (selected?.value) {
                dispatch(getAllDateTableTask({ data: { boardId: selected.value } }));
            }
        } catch (e) {
            console.error(e);
        } finally {
            setBoardLoading(false);
            setIsBoardFetched(true);
        }
    };

    useEffect(() => {
        const token = localStorage.getItem('access_token');
        if (role && !isBoardFetched && !boardLoading && token) {
            setBoardLoading(true);
            if (role === 'User') {
                getBoardColumnById();
            } else {
                getAllBoard();
            }
        }
    }, [role, isBoardFetched, boardLoading]);

    useEffect(() => {
        const handleAuthMessage = (event) => {
            if (event.data?.token && role && !isBoardFetched && !boardLoading) {
                setBoardLoading(true);
                if (role === 'User') {
                    getBoardColumnById();
                } else {
                    getAllBoard();
                }
            }
        };

        window.addEventListener('message', handleAuthMessage);
        return () => window.removeEventListener('message', handleAuthMessage);
    }, [role, isBoardFetched, boardLoading]);
    useEffect(() => {
        const token = localStorage.getItem('access_token');
        if (token && selectedBoardId) {
            getTaskMail();
        }
    }, [selectedBoardId, activeButton]);

    const getCurrentBoardId = () => {
        if (selectedBoardId) {
            return selectedBoardId;
        }

        const savedBoard = localStorage.getItem('board');
        if (savedBoard) {
            try {
                const parsedBoard = JSON.parse(savedBoard);
                return parsedBoard.value;
            } catch (error) {
                console.error('Error parsing saved board:', error);
            }
        }

        return null;
    };

    return (
        <div>
            <DndProvider backend={HTML5Backend}>
                <div className="h-full overflow-hidden">
                    <Header
                        columns={columns}
                        filterList={filterList}
                        emailName={emailName}
                        handleChange={handleChange}
                        handleSelectedBoard={handleSelectedBoard}
                        setSelectedBoardId={setSelectedBoardId}
                        handleAddColumn={handleAddColumn}
                        selectedBoardId={selectedBoardId}
                        selectedEmailsIds={selectedEmailsIds}
                        role={role}
                        setSelectedBoard={setSelectedBoard}
                        selectedBoard={selectedBoard}
                        getTaskMailIndbox={getAllInboxMailFilter}
                        getAllBoard={getAllBoard}
                        boardName={boardName}
                        setBoardName={setBoardName}
                        getTaskMail={getTaskMail}
                        activeButton={activeButton}
                        setActiveButton={setActiveButton}
                        setTaskMail={setTaskMail}
                    />
                    {role != 'User' ? (
                        <div className="grid grid-cols-[27%_auto] border-2">
                            <div className="overflow-y-scroll h-[calc(100vh_-_40px)]">
                                <div
                                    style={{
                                        marginTop: '3px',
                                    }}
                                >
                                    <div style={{ position: 'relative', width: '100%' }}>
                                        <input
                                            type="text"
                                            value={searched}
                                            onChange={(e) => requestSearch(e.target.value)}
                                            placeholder="Search..."
                                            style={{
                                                width: '100%',
                                                padding: '10px 16px',
                                                fontSize: '14px',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px',
                                                outline: 'none',
                                                background: 'none',
                                            }}
                                        />
                                        {searched && (
                                            <button
                                                onClick={() => cancelSearch()}
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    background: 'none',
                                                    border: 'none',
                                                    color: '#757575',
                                                    fontSize: '20px',
                                                    cursor: 'pointer',
                                                    padding: '0 4px',
                                                }}
                                                aria-label="Clear search"
                                            >
                                                ×
                                            </button>
                                        )}
                                    </div>
                                </div>

                                {selectedTab === 'GMAIL' && filterList && role !== 'User' && (
                                    <div className="drop-header">
                                        <MultiSelect
                                            options={filterList}
                                            value={selectedEmailsIds}
                                            onChange={handleChange}
                                            labelledBy="Select Emails"
                                        />
                                    </div>
                                )}

                                {selectedTab == 'WHATSAPP' && (
                                    <div className="flex justify-between px-2.5 mt-6 items-center mb-[10px] border-b-2">
                                        <div className="flex gap-3 items-center">
                                            <div
                                                className={`flex gap-1.5 cursor-pointer ${getColorWhatsapp(
                                                    'allWhatsappChat',
                                                )}`}
                                                onClick={() => setSelectedWhatspp('allWhatsappChat')}
                                            >
                                                <img src="./assets/primary.svg" alt="All" />
                                                <span>All</span>
                                            </div>
                                            <div
                                                className={`flex gap-1.5 cursor-pointer ${getColorWhatsapp(
                                                    'groupWhatsappChat',
                                                )}`}
                                                onClick={() => setSelectedWhatspp('groupWhatsappChat')}
                                            >
                                                <img src="./assets/primary.svg" alt="Group" />
                                                <span>Group</span>
                                            </div>

                                            <div className="flex gap-1.5 cursor-pointer items-center">
                                                <select
                                                    className="border border-gray-300 rounded px-2 py-0.5 text-sm"
                                                    style={{ marginLeft: '12px', width: '80%' }}
                                                    value={selectedProfileId}
                                                    onChange={(e) => handleProfileChange(e.target.value)}
                                                >
                                                    {allWhatsaapUserProfile &&
                                                        allWhatsaapUserProfile?.map((item) => (
                                                            <option key={item?.id} value={item?.id}>
                                                                {item?.name}
                                                            </option>
                                                        ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {selectedTab == 'GMAIL' && (
                                    <div onScroll={handleScroll} className="inbox-Mail">
                                        {generateMailInbox()}
                                    </div>
                                )}

                                {selectedTab == 'WHATSAPP' && (
                                    <div className="sid ebar-container">
                                        <div className="inbox-Mail" ref={sidebarRef} onScroll={handleScrollWhatsapp}>
                                            {generateWhatsAppInbox()}
                                            {loading && <p>Loading more items...</p>}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <TaskContext.Provider
                                value={{
                                    tasks,
                                    setTasks,
                                    updateTitleInLocalStorage,
                                    isModalOpen,
                                    handleCloseModal,
                                    getTaskMailIndbox,
                                }}
                            >
                                <ColumnContext.Provider
                                    value={{
                                        columns,
                                        setColumns,
                                        addTaskToColumn,
                                        updateColunTitleInLocalStorage,
                                        updateDeadlineDateInLocalStorage,
                                        moveTaskUp,
                                        moveTaskDown,
                                        isModalOpen,
                                        handleCloseModal,
                                        getTaskMailIndbox,
                                        handleAddColumn,
                                        columnAddStatus,
                                        setColumnAddStatus,
                                        filterList,
                                        handleUpdateTask,
                                        selectedBoardId,
                                        setSelectedBoardId,
                                        moveColumn,
                                        taskMail,
                                        setTaskMail,
                                        getTaskMail,
                                        setSortBy,
                                        setSortOrder,
                                        sortby,
                                        sortOrder,
                                        getAllBoard,
                                        activeButton,
                                    
                                    }}
                                >
                                    <div className="overflow-x-auto overflow-y-auto h-[100vh] relative">
                                        <Board
                                            isModalOpen={isModalOpen}
                                            onClose={handleCloseModal}
                                          
                                        />
                                    </div>
                                </ColumnContext.Provider>
                            </TaskContext.Provider>
                        </div>
                    ) : (
                        <div
                            style={role == 'User' ? { marginLeft: '20px' } : {}}
                            className="border-r border-r-solid border-r-gray-400 w-full"
                        >
                            <TaskContext.Provider value={{ tasks, setTasks, updateTitleInLocalStorage }}>
                                <ColumnContext.Provider
                                    value={{
                                        columns,
                                        setColumns,
                                        addTaskToColumn,
                                        updateColunTitleInLocalStorage,
                                        updateDeadlineDateInLocalStorage,
                                        moveTaskUp,
                                        moveTaskDown,
                                        handleAddColumn,
                                        getTaskMailIndbox,
                                        columnAddStatus,
                                        setColumnAddStatus,
                                        filterList,
                                        handleUpdateTask,
                                        selectedBoardId,
                                        moveColumn,
                                        taskMail,
                                        setTaskMail,
                                        getTaskMail,
                                        getAllBoard,
                                    }}
                                >
                                    <Board moduleName={moduleName} />
                                </ColumnContext.Provider>
                            </TaskContext.Provider>
                        </div>
                    )}
                </div>
                {whatsAppStatus && (
                    <WhatsAppAuth whatsAppStatus={whatsAppStatus} onClose={() => dispatch(setWhatsAppStatus(false))} />
                )}
                {emailStatus && <EmailAuth emailStatus={emailStatus} onClose={() => dispatch(setEmailStatus(false))} />}
            </DndProvider>
        </div>
    );
};

export default AppViewer;
